import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { useForecastFileUploadQuery as useForecastFileUploadQueryType } from "@/modules/admin/capacity/services/__generated__/useForecastFileUploadQuery.graphql"

const forecastFileUploadQuery = graphql`
  query useForecastFileUploadQuery {
    forecastFileUpload {
      id
      uploadBy
      uploadAt
    }
  }
`

export function useForecastFileUploadQuery() {
  const data = useLazyLoadQuery<useForecastFileUploadQueryType>(
    forecastFileUploadQuery,
    {},
    {
      fetchPolicy: "network-only",
    },
  )

  return data
}
